import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="bg-white text-black border-t border-gray-200 mt-auto">
            <div className="px-4 py-4 text-center text-sm text-gray-600">
                <p>
                    © {new Date().getFullYear()}{" "}
                    <a
                        href="https://dakopen.de"
                        className="hover:underline underline-black text-gray-700"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Daniel Busch
                    </a>{" "}
                    ·{" "}
                    <Link to="/privacy" className="hover:underline underline-black text-gray-700">
                        {t("privacyPolicy")}
                    </Link>{" "}
                    ·{" "}
                    <Link to="/legal" className="hover:underline underline-black text-gray-700">
                        {t("legalNotice")}
                    </Link>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
